import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { useProductData } from '../data'

export function ProductDataBoundary({ children }: { children?: ReactNode }) {
  const { loading, error, data } = useProductData()

  if (loading) return <div className="loading-state">正在加载京东商品经营数据…</div>
  if (error || !data) {
    return (
      <div className="error-state">
        <h1>京东数据加载失败</h1>
        <p>{error || '京东商品数据不可用'}</p>
        <p>其他平台仍可从顶部平台范围继续访问。</p>
      </div>
    )
  }

  return children ?? <Outlet />
}
